import gql from 'graphql-tag'

/**
 * GraphQL fragment with every PAMM offer field the hierarchical tree view needs.
 *
 * Shared by both the Money Manager (`pammOffers`) and Agent (`pammAgentOffers`) queries
 * so the two pages produce an identical `PammOfferType` shape for `PammOffersTree`.
 */
export const PAMM_OFFER_TREE_FIELDS = gql`
  fragment PammOfferTreeFields on PammOfferType {
    id
    name
    # totalInvestments is a server-computed investor count and is populated for both
    # Money Manager and Agent offers; activeInvestmentCount is only set on Agent offers.
    totalInvestments
    currency
    managerId
    managerName
    totalDepositSum
    skygroundAccountId
    # The investor book is fetched with the tree rather than on popover open: PT-5707 fixes the
    # open time at under 100 ms for 500 rows, which a request issued on click cannot promise.
    # The server only ever returns this for nodes the viewer owns (PT-5708).
    investors {
      id
      name
      funds
      share
      created
      # Masked server-side to j***@domain for an upstream agent who does not own this node;
      # emailMasked says which it is, so the row knows not to offer it as a mailto (PT-5709).
      email
      emailMasked
    }
    settings {
      agentChain {
        agentId
        client {
          id
        }
      }
      tradingInterval {
        type
        count
      }
      minDeposit
      minInitialInvestment
      minWithdrawal
      performanceFees {
        levels {
          level
          value
        }
        mode
      }
    }
  }
`
